import React from "react";
import styles from "./ModalComponent.module.css";
import { Modal } from "antd";
import { TbLockCheck } from "react-icons/tb";
import lock from "../../assets/images/lockImg.png";
import TextComponent from "../textComponent/TextComponent";
import SubmitButton from "../submitButton/SubmitButton";
const ModalComponent = ({
  open,
  onCancel,
  className,
  image,
  imageClass,
  width,
  title,
  headingClass,
  textClass,
  buttonTitle,
  onBtnPress,
  text,
  btnClass,
  twoButton,
  onClickOkButton,
  onClickCancelButton,
  okBtnTitle,
  cancelBtnTitle,
  btnDiv,
  okbtnClass,
  cancelbtnClass,
  children,
  btnStyle,
  leftBtnIcon,
  closable,
  fontFamily,
  SingleButtonClass,
  SinglebtnContainerClass,
  icon,
  IconClass,
  onIconClick,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={false}
      // width={width ? width : "40%"}
      className={`${className} ${styles.modalCont}`}
      closable={closable ? closable : true}
      //   className=""
    >
      {icon &&
        (icon ? (
          <div
            className={`${IconClass} ${styles.IconBox}`}
            onClick={onIconClick}
          >
            {icon}
          </div>
        ) : image ? (
          <div className={`${imageClass} ${styles.imageBox}`}>
            <img src={lock} className={styles.image} />
          </div>
        ) : null)}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {title && (
          <TextComponent
            id={"title"}
            text={title}
            className={`${headingClass} ${styles.heading}`}
          />
        )}
        {text && (
          <TextComponent
            text={text}
            className={textClass}
            fontFamily={fontFamily}
          />
        )}
        {children}

        {buttonTitle ? (
          <SubmitButton
            primary
            title={buttonTitle}
            onClick={onBtnPress}
            style={btnStyle ? btnStyle : { width: "90%" }}
          />
        ) : twoButton ? (
          <div className={`${btnDiv} ${styles.btnDiv}`}>
            <SubmitButton
              leftIcon={leftBtnIcon}
              title={okBtnTitle}
              onClick={onClickOkButton}
              primary
              style={btnStyle ? btnStyle : { width: "90%" }}
            />
            <SubmitButton
              secondary
              title={cancelBtnTitle}
              onClick={onClickCancelButton}
              style={btnStyle ? btnStyle : { width: "90%" }}
            />
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default ModalComponent;
